<div class="snippet-container">
    <ng-container *ngIf="!editMode">
        <div class="row equal " [ngClass]="{'no-gutters' : !snippet.gridGutters}">
            <ng-container *ngFor="let g of snippet.grid">
                <div
                    *ngIf="!g.bgImage"
                    class="col d-flex flex-column align-items-center snippet-container"
                    [ngClass]="[g.paddingH, g.paddingV, g.backgroundColour]"
                    [innerHTML]="g.content | safeHTML">
                </div>
                <div
                    *ngIf="g.bgImage"
                    class="col d-flex flex-column align-items-center snippet-container cms-image-tile"
                    [ngStyle]="{'background-image': 'url(' + g.bgImage + ')'}"
                    [ngClass]="[g.paddingH, g.paddingV, g.backgroundColour]"
                    [innerHTML]="g.content | safeHTML">
                </div>
            </ng-container>
        </div>

        <div class="row no-gutters">
            <div class="col" *ngFor="let g of snippet.grid">
                <div class="text-end mt-2">
                    <button class="btn btn-sm btn-primary ms-2" (click)="backgroundImage(g)">Background Image</button>
                    <button class="btn btn-sm btn-primary ms-2" (click)="editSnippet()">Edit</button>
                    <button class="btn btn-sm btn-primary ms-2" (click)="edit()">Edit text</button>
                </div>
            </div>
        </div>

        <div class="text-end mt-2">
            <button class="btn btn-sm btn-danger" (click)="deleteConfirm()">Remove row</button>
        </div>
    </ng-container>

    <ng-container *ngIf="editMode">
        <div class="row equal " [ngClass]="{'no-gutters' : !snippet.gridGutters}">
            <ng-container *ngFor="let g of snippet.grid">
                <div
                    [style.height]="snippet.gridHeight + 'px'"
                    class="col d-flex flex-column align-items-center snippet-container"
                    *ngIf="!g.bgImage">
                    <editor
                        [(ngModel)]="g.content"
                        [apiKey]="this.env.tinymceApiKey"
                        [init]="tinyInit"></editor>
                </div>
                <div
                    *ngIf="g.bgImage"
                    [style.height]="snippet.gridHeight + 'px'"
                    class="col d-flex flex-column align-items-center snippet-container cms-image-tile"
                    [ngStyle]="{'background-image': 'url(' + g.bgImage + ')'}">
                    <editor
                        [(ngModel)]="g.content"
                        [apiKey]="this.env.tinymceApiKey"
                        [init]="tinyInit"></editor>
                </div>
            </ng-container>

        </div>
        <div class="row mb-2 no-gutters">
            <div class="col" *ngFor="let g of snippet.grid; let i = index">
                <div class="row">
                    <div class="col">
                        <div *ngIf="i === 0">
                            <button class="btn btn-sm btn-danger" (click)="deleteConfirm()">Remove row</button>
                            <button class="btn btn-sm btn-primary ms-2" (click)="editSnippet()">Edit row</button>
                        </div>
                    </div>
                    <div class="col text-end">
                        <button class="btn btn-sm btn-primary ms-2" (click)="backgroundImage(g)">
                            <span *ngIf="!g.bgImage">Background image</span>
                            <span *ngIf="g.bgImage">Swap image</span>
                        </button>
                        <button class="btn btn-sm btn-danger ms-2" *ngIf="g.bgImage" (click)="g.bgImage = ''">Remove image</button>
                        <!--                    <button class="btn btn-sm btn-primary ms-2" (click)="edit()">Edit text</button>-->
                    </div>
                </div>
            </div>
        </div>

    </ng-container>


   <div class="text-end mt-30">
       <button class="btn btn-sm btn-primary ms-2" (click)="save()">Save</button>
    </div>
</div>

<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="imageModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>
<app-confirmation *ngIf="this.confirmationData.open" (complete)="confirmAction($event)" [data]="confirmationData"></app-confirmation>

<app-snippet-edit [snippet]="snippet" (modalAction)="editModalAction($event)" *ngIf="snippetEditModal"></app-snippet-edit>
<app-images *ngIf="showImageLibrary" [ownerId]="'cms'" [type]="imageLibraryType" [allowSelection]="false" (modalAction)="imageModalAction($event)" (imageSelected)="imageSelected($event)"></app-images>
